import React, { useState } from "react";
import MugSlider from "./components/MugSlider";
import VaseSlider from "./components/VaseSlider";
import { Link } from "react-router-dom";
import AllProductsGrid from "./components/AllProductsGrid";



function HomePage() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans">
      {/* HEADER */}



      {/* HERO */}
      <section
  className="relative h-[70vh] bg-center bg-cover flex items-center justify-center text-center px-6"
  style={{ backgroundImage: 'url(/images/hero-bg.png)' }}
>
  <div className="absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm" />
  <div className="relative z-10 text-white">
    <h1 className="text-5xl font-sans mb-4 drop-shadow-md">Sade, Şık ve El yapımı.</h1> 

    
    <p className="text-xl text-gray-200 drop-shadow-sm">Seratics</p>
  </div>
  <a
  href="#products"
  className="absolute bottom-6 inset-x-0 mx-auto w-fit animate-slow-bounce opacity-80 hover:opacity-100 transition z-20"
  aria-label="Sayfayı aşağı kaydır">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6 text-white"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
</a>
</section>


      {/* ÜRÜNLER */}
      <section id="products" className="px-6 py-12 max-w-5xl text-center mx-auto">
       <MugSlider />
      <Link to="/all-products"
  className="mt-6 inline-block px-6 py-3 bg-stone-900 text-white rounded-full 
  text-sm font-medium shadow hover:bg-stone-800 transition"
>Tüm kataloğu Gör
</Link>

      </section>


      {/* HAKKIMIZDA */}
      <section id="about" className="bg-slate-200 backdrop-blur-xl px-6 py-12 text-center">
        <h3 className="text-3xl font-bold mb-6">Hakkımda</h3>
        <p className="max-w-xl mx-auto text-stone-900 text-xl leading-relaxed">
          Seratics, sade ve şık seramik tasarımlarıyla zamansız ürünler sunar. Tüm ürünler el yapımı olup; estetik, fonksiyonel ve doğaldır.
        </p>
      </section>

      {/* İLETİŞİM */}
      <section id="contact" className="px-6 py-12 text-center">
        <h3 className="text-3xl font-bold mb-6">İletişim</h3>
        <p className="text-xl text-stone-900 mb-6">Instagram'dan bize ulaşabilirsiniz.</p>
        <a
          href="https://instagram.com/seratics.art"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition"
        >
          Instagram
        </a>
      </section>

      

      {/* FOOTER */}
    </div>
  );
}

export default HomePage;
